import React, { useState, useEffect, useCallback } from 'react';
import JoinRitualsModal from './JoinRitualsModal';

const STORAGE_KEY = 'melanua_popup_last_shown';
const DISMISSED_KEY = 'melanua_popup_dismissed';
const SUBSCRIBED_KEY = 'melanua_popup_subscribed';

export default function AutoPopup() {
    const [isOpen, setIsOpen] = useState(false);
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        fetch('/api/content/join-modal/')
            .then(response => response.ok ? response.json() : null)
            .then(setSettings)
            .catch(() => {});
    }, []);

    const shouldShowPopup = useCallback(() => {
        if (!settings?.show_popup_on_visit) return false;
        try {
            if (sessionStorage.getItem(DISMISSED_KEY) === 'true' ||
                localStorage.getItem(SUBSCRIBED_KEY) === 'true') return false;
            const lastShown = Number(localStorage.getItem(STORAGE_KEY));
            const hours = settings.popup_frequency_hours ?? 24;
            if (lastShown && Date.now() - lastShown < hours * 60 * 60 * 1000) return false;
        } catch (_) {
            // Browsers may disable storage; the delayed trigger still applies.
        }
        return true;
    }, [settings]);

    useEffect(() => {
        if (!shouldShowPopup()) return;
        let shown = false;
        const onScroll = () => {
            const scrollable = document.documentElement.scrollHeight - window.innerHeight;
            if (scrollable > 0 && window.scrollY / scrollable >= .45) show();
        };
        const show = () => {
            if (shown || !shouldShowPopup()) return;
            shown = true;
            setIsOpen(true);
            try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (_) {}
            window.removeEventListener('scroll', onScroll);
        };
        const delay = Math.max(20, Number(settings.popup_delay_seconds) || 25) * 1000;
        const timer = window.setTimeout(show, delay);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            window.clearTimeout(timer);
            window.removeEventListener('scroll', onScroll);
        };
    }, [settings, shouldShowPopup]);

    return <JoinRitualsModal isOpen={isOpen} onClose={() => setIsOpen(false)} />;
}

export function dismissPopupForSession() {
    try { sessionStorage.setItem(DISMISSED_KEY, 'true'); } catch (_) {}
}

export function markPopupSubscribed() {
    dismissPopupForSession();
    try { localStorage.setItem(SUBSCRIBED_KEY, 'true'); } catch (_) {}
}
